// HomePage.jsx
import { useTranslation } from "react-i18next";
import "./HomePage.css";

// Component imports
import HeroSection from "./components/HeroSection";
import LevelsSection from "./components/LevelsSection";
import ThemesSection from "./components/ThemesSection";
import ServicesSection from "./components/ServicesSection";
import PricingSection from "./components/PricingSection";
import RGPDSection from "./components/RGPDSection";
import CTASection from "./components/CTASection";
function HomePage() {
  const { t } = useTranslation("global");

  return (
    <div className="homepage">
      <HeroSection
        actionBtnName={t("home.first-section-free-trial")}
        primaryColor="blue-600"
        heading={t("home.first-section-heading")}
        subHeading={t("home.first-section-subHeading")}
      />
      
      <LevelsSection />
      
      <ThemesSection />
      
      <ServicesSection />
      
      {/* <PricingSection /> */}
      
      <RGPDSection />
      
      <CTASection />
    </div>
  );
}

export default HomePage;